import { useEffect, useState } from "react";

let ready = false;
const listeners = new Set();

export function setProspectSetupReady(next) {
  const value = !!next;
  if (value === ready) return;
  ready = value;
  listeners.forEach((fn) => fn(ready));
}

export function useProspectSetupReady() {
  const [value, setValue] = useState(ready);
  useEffect(() => {
    const listener = (next) => setValue(next);
    listeners.add(listener);
    setValue(ready);
    return () => listeners.delete(listener);
  }, []);
  return value;
}

/** A live channel connection. Publishing alone is not enough. */
export function prospectHasLiveIntegration(bots) {
  return (bots || []).some((bot) => {
    if (bot?.instagram?.connected || bot?.whatsapp?.connected) return true;
    return Boolean(bot?.embedLastSeenAt || bot?.knowledgeStats?.embed_last_seen_at);
  });
}
